module.exports = "<router-outlet></router-outlet>\n<ae-scroll-position></ae-scroll-position>\n\n\n"